'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { calculateOperatingMargin } from './calculations';
import { OperatingMarginValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['operatingMargin'];
}

export default function OperatingMarginCalculator({ translations }: Props) {
  const [values, setValues] = useState<OperatingMarginValues>({
    operatingIncome: 250000,
    revenue: 2000000,
    currency: 'kr',
  });

  const handleValuesChange = (field: keyof OperatingMarginValues, value: number | string) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateOperatingMargin(values, translations), [values, translations]);

  return (
    <section id="operating-margin-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
              <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
            </div>
          </div>
        </div>
        <div className="p-6 space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
            <ResultsDisplay result={result} translations={translations} />
          </div>
        </div>
      </div>
    </section>
  );
}


